import Layout from 'components/layout';
import ContentPage from 'components/content-pages';
import { handleContentPageServerSideProps } from 'utils/content-pages';
import { createGetServerSideProps, type HandlerType } from 'utils/next/shared-getServerSideProps';
import { FeaturesType } from 'contexts';
import { TenantIds, TenantTypes } from '@tenants';

import type { GetServerSidePropsContext } from 'next';
import type { ContentPageProps } from 'types/content-pages';

const handler: HandlerType<ContentPageProps> = async (_context: GetServerSidePropsContext, _features?: FeaturesType, tenant?: TenantTypes) => {
  return await handleContentPageServerSideProps(tenant.id, [
    TenantIds.EXP_REALTY_US,
  ], '/reo', 'ALL');
};

export const getServerSideProps = createGetServerSideProps(handler);

export default function ExpReoPage(props: ContentPageProps) {
  return (
    <Layout>
      <ContentPage {...props} />
    </Layout>
  );
}
